interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const getPages = (): (number | '...')[] => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages: (number | '...')[] = [1];
    if (currentPage > 4) pages.push('...');
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    if (currentPage < totalPages - 3) pages.push('...');
    pages.push(totalPages);
    return pages;
  };

  return (
    <nav className="flex items-center justify-center gap-0.5 sm:gap-1 mt-8 sm:mt-10 md:mt-12 flex-wrap" aria-label="Paginação">
      {/* Anterior */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-200 text-foreground-500 hover:border-primary-300 hover:text-primary-500 hover:bg-primary-50/60 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer whitespace-nowrap"
        aria-label="Página anterior"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {getPages().map((page, i) =>
        page === '...' ? (
          <span
            key={`dots-${i}`}
            className="w-9 h-9 flex items-center justify-center text-foreground-400 text-sm select-none"
          >
            …
          </span>
        ) : (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-semibold border transition-all cursor-pointer whitespace-nowrap ${
              page === currentPage
                ? 'bg-primary-500 text-white border-primary-500'
                : 'border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-500 hover:bg-primary-50/60'
            }`}
            aria-current={page === currentPage ? 'page' : undefined}
          >
            {page}
          </button>
        )
      )}

      {/* Próxima */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-200 text-foreground-500 hover:border-primary-300 hover:text-primary-500 hover:bg-primary-50/60 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer whitespace-nowrap"
        aria-label="Próxima página"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}